// @ts-nocheck
import { useState } from 'react';
// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import {
  Stack,
  Button,
  Modal,
  TextInput,
  Group,
  Loader,
  Center,
} from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { useDisclosure } from '@mantine/hooks';
import { PageHeader } from '../../components/PageHeader';
import { DataTable, type Column } from '../../components/DataTable';
import { StatusBadge } from '../../components/StatusBadge';
import { useBranches, useCreateBranch } from '../../hooks/useCompany';

interface Branch {
  [key: string]: unknown;
  id: string;
  name: string;
  status: string;
  address: {
    city: string;
    state: string;
  } | null;
}

export function BranchListPage() {
  const [addOpened, { open: openAdd, close: closeAdd }] = useDisclosure(false);
  const [form, setForm] = useState({ name: '', city: '', state: '' });

  const { data: queryData, loading: isLoading } = useBranches();
  const [createBranch, { loading: isCreating }] = useCreateBranch();
  const branchData = queryData as { branches?: Branch[] } | undefined;
  const branches = branchData?.branches;

  const columns: Column<Branch>[] = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
    },
    {
      key: 'city',
      label: 'City',
      render: (branch) => branch.address?.city || '-',
    },
    {
      key: 'state',
      label: 'State',
      width: 100,
      render: (branch) => branch.address?.state || '-',
    },
    {
      key: 'status',
      label: 'Status',
      width: 120,
      render: (branch) => <StatusBadge status={branch.status} />,
    },
  ];

  const handleAdd = async () => {
    try {
      await createBranch({
        variables: {
          input: {
            name: form.name,
            address: {
              city: form.city || null,
              state: form.state || null,
            },
          },
        },
      });
      closeAdd();
      setForm({ name: '', city: '', state: '' });
    } catch (error) {
      console.error('Failed to create branch:', error);
    }
  };

  return (
    <Stack gap="md">
      <PageHeader
        title="Branches"
        subtitle={branches ? `${branches.length} branches` : undefined}
        actions={
          <Button icon={<IconPlus size={16} />} onClick={openAdd}>
            Add Branch
          </Button>
        }
      />

      {isLoading ? (
        <Center py="xl">
          <Loader size="lg" />
        </Center>
      ) : (
        <DataTable<Branch>
          data={branches ?? []}
          columns={columns}
          getRowKey={(row) => row.id}
          emptyMessage="No branches found"
        />
      )}

      <Modal opened={addOpened} onClose={closeAdd} title="Add Branch" size="md">
        <Stack gap="sm">
          <TextInput
            label="Branch Name"
            placeholder="Enter branch name"
            required
            value={form.name}
            onChange={(e) =>
              setForm((f) => ({ ...f, name: e.currentTarget.value }))
            }
          />
          <TextInput
            label="City"
            placeholder="Enter city"
            value={form.city}
            onChange={(e) =>
              setForm((f) => ({ ...f, city: e.currentTarget.value }))
            }
          />
          <TextInput
            label="State"
            placeholder="Enter state code (e.g., CA)"
            value={form.state}
            onChange={(e) =>
              setForm((f) => ({ ...f, state: e.currentTarget.value }))
            }
          />
          <Group justify="flex-end" mt="md">
            <Button variant="subtle" onClick={closeAdd}>
              Cancel
            </Button>
            <Button onClick={handleAdd} disabled={!form.name || isCreating} loading={isCreating}>
              Create Branch
            </Button>
          </Group>
        </Stack>
      </Modal>
    </Stack>
  );
}
